import * as React from "react";
const loaderCircle = React.createElement("div", { className: "rj-loader-circle" });
export class Loader extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-loader" },
            React.createElement("div", { className: "rj-loader-spinner rj-loader-container" },
                React.createElement("div", { className: "rj-loader-spinner rj-loader-fill" },
                    React.createElement("div", { className: "rj-loader-clipper left" }, loaderCircle),
                    React.createElement("div", { className: "rj-loader-gap-patch" }, loaderCircle),
                    React.createElement("div", { className: "rj-loader-clipper right" }, loaderCircle)))));
    }
}
//# sourceMappingURL=Loader.js.map